import React from "react";
import { useTranslation } from "react-i18next";

function WhatIsTaoluSection() {
  const { t } = useTranslation();

  const cards = [
    {
      icon: "fas fa-list-ol",
      title: t("taolu_what_is.card1.title"),
      description: t("taolu_what_is.card1.description"),
    },
    {
      icon: "fas fa-bullseye",
      title: t("taolu_what_is.card2.title"),
      description: t("taolu_what_is.card2.description"),
    },
    {
      icon: "fas fa-yin-yang",
      title: t("taolu_what_is.card3.title"),
      description: t("taolu_what_is.card3.description"),
    },
  ];

  return (
    <section className="pt-12 pb-12 bg-white dark:bg-slate-800 transition-colors" id="what-is-taolu-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="mb-8 text-center">
          <h2 className="text-4xl md:text-5xl mb-5 text-primary dark:text-primary-light relative inline-block">
            {t("taolu_what_is.title")}
            {/* Underline decoration */}
            <div className="absolute -bottom-2.5 left-1/2 transform -translate-x-1/2 w-15 h-0.5 bg-primary dark:bg-primary-light rounded-sm" />
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {cards.map((item, index) => (
            <div
              key={index}
              className="bg-slate-50 dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm p-6 hover:shadow-md transition-all duration-200"
            >
              <div className="flex flex-col items-center text-center space-y-4">
                {/* Icon */}
                <div className="flex-shrink-0 w-16 h-16 rounded-full bg-primary/10 dark:bg-primary-light/20 flex items-center justify-center">
                  <i className={`${item.icon} text-primary dark:text-primary-light text-2xl`}></i>
                </div>
                
                {/* Content */}
                <div className="space-y-2">
                  <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100">
                    {item.title}
                  </h3>
                  <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Text Content */}
        <div className="max-w-4xl mx-auto">
          <p className="text-slate-600 dark:text-slate-400 text-lg leading-relaxed whitespace-pre-line">
            {t("taolu_what_is.text")}
          </p>
        </div>
      </div>
    </section>
  );
}

export default WhatIsTaoluSection;

